import { fill } from 'lodash'
import { Box } from './_shared/Box'
import { Pencil } from './icons'
import { formatNumber } from '../../../../utils/tableFuncs'

export function CarMileage({ car, setShowEditMileage }: { car: any; setShowEditMileage: any }) {
  return (
    <Box
      title="Kjørelengde"
      actionComponent={
        <button onClick={() => setShowEditMileage(true)} className="text-old-primary">
          <Pencil />
        </button>
      }
    >
      <div className="flex w-full flex-col gap-4">
        {car.mileage <= car.contractMileage ? <BelowMileage car={car} /> : <AboveMileage car={car} />}
        <div className="flex items-center justify-between w-full">
          <p className="text-old-offGrey">
            <span
              className={`${car.mileage <= car.contractMileage ? 'text-old-primary' : 'text-old-warning'} font-bold`}
            >
              {formatNumber(car.mileage)} km
            </span>{' '}
            av {formatNumber(car.contractMileage)} km
          </p>
        </div>
        <p>Simulert kjørelengde er {formatNumber(car.simulatedMileage)} km</p>
      </div>
    </Box>
  )
}

export function BelowMileage({ car }) {
  const filledWidth = Number(((car.mileage / car.contractMileage) * 100).toFixed(0))

  const isEqual = car.mileage === car.contractMileage
  const remainingWidth = 100 - filledWidth
  return (
    <div className="w-full h-fit flex justify-between flex-row relative overflow-hidden">
      <div className="h-4 w-full right-0 absolute bg-white widthFromZeroToContent" />
      <div
        style={{ width: `${filledWidth}%` }}
        className={`h-3 bg-old-primary rounded-l-full ${isEqual && 'rounded-r-full'} `}
      ></div>
      <div style={{ translate: `${filledWidth}% 0` }} className={`absolute transform w-full -top-2`}>
        {filledWidth !== 0 && !isEqual && (
          <div className={`h-[30px] -translate-x-[6px] rotate-[45deg] w-[7.5px] bg-white transform`} />
        )}
      </div>
      <div style={{ width: `${remainingWidth}%` }} className={`h-3 bg-blue-100 rounded-r-full`}></div>
    </div>
  )
}

export function AboveMileage({ car }) {
  const filledWidth = Number(((car.contractMileage / car.mileage) * 100).toFixed(0))
  const isEqual = car.mileage === car.contractMileage
  const remainingWidth = 100 - filledWidth
  return (
    <div className="w-full h-fit flex justify-between flex-row relative">
      <div className="h-4 w-full right-0 absolute bg-white widthFromZeroToContent" />
      <div style={{ width: `${filledWidth}%` }} className={`h-3 bg-old-primary rounded-l-full`}></div>
      <div style={{ translate: `${filledWidth}% 0` }} className={`absolute transform w-full -top-2`}>
        {filledWidth !== 0 && !isEqual && (
          <div className={`h-[30px] -translate-x-[6px] rotate-[45deg] w-[6.5px] bg-white transform`} />
        )}
      </div>
      <div style={{ width: `${remainingWidth}%` }} className={`h-3 bg-old-warning rounded-r-full`}></div>
    </div>
  )
}
